import React, { PureComponent, createRef, forwardRef } from "react";
import { Draggable, Droppable } from "react-beautiful-dnd";
import Input from "../theme/forms/Input";
import { updateCrewCanvasser } from "../../store/api/calls";
import { connect } from "react-redux";
import { AvailRoleToken } from "./DraggableShiftCanvasser";
import { get as _get } from "lodash";
import api from "../../store/api/api";
import NoteTagList from "../theme/buttons/NoteTag";
import { setSessionVar } from "../../store/actions";

class RouteSeatAssigment extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      editingIsDriver: false,
      editingIsDriverValue: false,
      editingRole: false,
      editingRoleValue: null,
      editingGoal: false,
      editingGoalValue: null,
      editingGoalPrevValue: null,
      editingComments: false,
      editingCommentsValue: null,
      editingCommentsPrevValue: null,
      editingAssignmentPlaceholder: null,
      assignmentPlaceholderValue: null,
    };

    // handle ref creation to autofocus on click for text fields
    // necessary because we use the onBlur() event to dispatch updates
    this.goalInputRef = createRef();
    this.commentsInputRef = createRef();
    this.roleSelectRef = createRef();
  }

  componentDidMount() {
    let role = (this.props.seat.roles || []).find((d) => d.name !== "Driver");
    let isDriver = (this.props.seat.roles || [])
      .map((d) => d.name)
      .includes("Driver");
    this.setState({
      editingGoalValue: this.props.seat.goal,
      editingCommentsValue: this.props.seat.comments,
      editingRoleValue: role ? role.id : null,
      editingIsDriverValue: isDriver,
      assignmentPlaceholderValue: this.props.seat.assignment_placeholder_note,
    });
  }

  _updateParentState = (seat_changes) => {
    let { seat } = this.props;
    seat = { ...seat, ...seat_changes };
    this.props.onCrewCanvasserChange(seat);
  };

  _updateCrewCanvasser = (seat_changes) => {
    console.log("seat changes", seat_changes, this.props.seat);
    return updateCrewCanvasser({
      id: this.props.seat.id || this.props.seat.crewcanvasser_id,
      ...seat_changes,
    });
  };

  _setAssignmentNote = (data) => {
    api.post("/routeseatassignmentnotes/", data).catch((err) => {
      console.error("failed to update assignment note");
      this.setState({ assignmentPlaceholderValue: null });
    });
  };

  _updateSeat = (seat_changes) => {
    this._updateParentState(seat_changes);
    this._updateCrewCanvasser(seat_changes);
  };

  generateCanvasserDataLine = (canvasser_id) => {
    let c_data = this.props.canvassers.find((d) => d.id === canvasser_id);
    if (!c_data) {
      console.warn("ORPHAN CANVASSER ID: " + canvasser_id, c_data);
      return (
        <div
          className={"canvasser-line"}
          style={{ flex: 1, justifyContent: "space-between" }}
        >
          <div className={"line-item extra-long"}>
            <span className={"minor-title"}>Name</span>
            <span className={"edit-toggle no-click"}>This canvasser has been deactivated</span>
          </div>
          <div className="line-item" style={{ textAlign: "right" }}>
            <span className="minor-title">Unassign</span>
            <span
              className={"edit-toggle no-after"}
              onClick={() =>
                this.props.onCanvasserSelect(
                  canvasser_id,
                  this.props.seat.routeseat_id,
                  this.props.seat.crewcanvasser_id,
                  true
                )
              }
            >
              <i style={{ fontSize: ".8em" }} className={"fas fa-user-slash"} />
            </span>
          </div>
        </div>
      );
    }

    const _updateCrewCanvasserRole = (val) => {
      if (+val && val !== this.state.editingRoleValue) {
        let roles = [{ id: val }];
        if (this.state.editingRoleValue) {
          roles.push({ id: this.state.editingRoleValue, delete: true });
        }
        this._updateCrewCanvasser({ roles });
        //filter out everything but the driver role
        roles = _get(this.props, "seat.roles", []).filter((d) => d?.id === 1); //filter out everything but the driver
        // add the selected one back in
        this._updateParentState({
          roles: [...roles, c_data.abilities.find((d) => d.id === +val)],
        });
      }
      if (+val === 0) {
        this._updateCrewCanvasser({ roles: [] });
        this._updateParentState({
          roles: [
            ..._get(this.props, "seat.roles", []).filter((d) => d?.id === 1),
          ],
        });
      }

      this.setState({ editingRoleValue: +val }, () =>
        this.setState({ editingRole: false })
      );
    };

    const abilities = [];
    let isDriver = false;

    c_data.abilities.forEach((d) => {
      abilities.push(<AvailRoleToken role={d.name} key={d.id} />);
      if (d.name === "Driver") {
        isDriver = true;
      }
    });

    return (
      <div
        className={`canvasser-line`}
        style={{ marginBottom: this.props.displaySites ? "1em" : "0" }}
      >
        <div className={"line-item extra-long"}>
          <span className={"minor-title"}>Name</span>
          <span className={"edit-toggle no-click"}>
            {c_data.firstname} {c_data.lastname}
            <span className={"slashline"}>{c_data.metrics}</span>
            <div className="obj-data small-font">{abilities}</div>
          </span>
          {/*{this.props.driver ? 'SUGGESTED DRIVER SEAT ' : null}*/}
        </div>
        <div className={"line-item"}>
          <span className={"minor-title"}>Sites</span>
          <span className={"edit-toggle no-click"}>
            {this.props.seat.sites.length}
          </span>
        </div>
        {/*field if they can be a driver*/}
        {isDriver ? (
          <div className={"line-item"}>
            <span className={"minor-title"}>Driver</span>
            <span
              className={"edit-toggle"}
              onDoubleClick={() => {
                this.setState({
                  editingIsDriverValue: !this.state.editingIsDriverValue,
                });
                this._updateCrewCanvasser({
                  roles: [
                    { id: 1, delete: this.state.editingIsDriverValue ? 1 : 0 },
                  ],
                });

                //force remove driver element from array, or add, depending on where we are
                if (!this.state.editingIsDriverValue) {
                  this._updateParentState({
                    roles: [
                      ...this.props.seat.roles,
                      { id: 1, name: "Driver" },
                    ],
                  });
                } else {
                  this._updateParentState({
                    roles: _get(this.props, "seat.roles", []).filter(
                      (d) => d.id !== 1
                    ),
                  });
                }
              }}
            >
              {this.state.editingIsDriverValue ? (
                <span style={{ fontWeight: "bold" }}>Yes</span>
              ) : (
                <span
                  style={{
                    opacity: 0.7,
                    fontStyle: "italic",
                    fontSize: ".8em",
                  }}
                >
                  No
                </span>
              )}
            </span>
          </div>
        ) : (
          <div className={"line-item"}></div>
        )}
        <div className={"line-item long"}>
          <span className={"minor-title"}>Role</span>
          {!this.state.editingRole && (
            <span
              className={"edit-toggle"}
              onDoubleClick={() => this.setState({ editingRole: true })}
            >
              {this.state.editingRoleValue ? (
                (
                  _get(c_data, "abilities", []).find(
                    (d) => d.id === +this.state.editingRoleValue
                  ) || { name: " " }
                ).name
              ) : (
                <span
                  style={{
                    opacity: 0.7,
                    fontStyle: "italic",
                    fontSize: ".8em",
                  }}
                >
                  None
                </span>
              )}
            </span>
          )}
          {this.state.editingRole && (
            <Input
              type={"select"}
              options={[
                {
                  display: "- -",
                  value: 0,
                },
                ...c_data.abilities
                  .filter((d) => d.name !== "Driver")
                  .map((d) => ({
                    display: d.name,
                    value: d.id,
                  })),
              ]}
              onChange={_updateCrewCanvasserRole}
              onBlur={() => this.setState({ editingRole: false })}
              value={this.state.editingRoleValue}
            />
          )}
        </div>
        <div className={"line-item"}>
          <span className={"minor-title"}>Goal</span>
          {!this.state.editingGoal && (
            <span
              className={"edit-toggle"}
              onDoubleClick={() =>
                this.setState({ editingGoal: true }, () => {
                  this.goalInputRef.current.focus();
                })
              }
            >
              {this.state.editingGoalValue || (
                <span
                  style={{
                    opacity: 0.7,
                    fontStyle: "italic",
                    fontSize: ".8em",
                  }}
                >
                  --
                </span>
              )}
            </span>
          )}
          {this.state.editingGoal && (
            <input
              className={"edit-toggle"}
              type="number"
              value={this.state.editingGoalValue}
              onChange={(ev) => {
                this.setState({ editingGoalValue: ev.target.value });
              }}
              onBlur={() => {
                this.setState({ editingGoal: false });
                this._updateSeat({ goal: this.state.editingGoalValue });
              }}
              ref={this.goalInputRef}
            />
          )}
        </div>
        <div className={"line-item long"}>
          <span className={"minor-title"}>Comments</span>
          {!this.state.editingComments && (
            <span
              className={"edit-toggle"}
              onDoubleClick={() =>
                this.setState({ editingComments: true }, () => {
                  this.commentsInputRef.current.focus();
                })
              }
            >
              {this.state.editingCommentsValue || (
                <span
                  style={{
                    opacity: 0.7,
                    fontStyle: "italic",
                    fontSize: ".8em",
                  }}
                >
                  None
                </span>
              )}
            </span>
          )}
          {this.state.editingComments && (
            <input
              className={"edit-toggle"}
              type="text"
              value={this.state.editingCommentsValue}
              onChange={(ev) => {
                let val = ev.target.value;
                this.setState({ editingCommentsValue: val });
              }}
              onBlur={() => {
                this.setState({ editingComments: false });
                this._updateSeat({ comments: this.state.editingCommentsValue });
              }}
              ref={this.commentsInputRef}
            />
          )}
        </div>
        <div className={"line-item"}>
          <span className={"minor-title"}>Unassign</span>
          <span
            className={"edit-toggle no-after"}
            style={{ marginLeft: ".2em" }}
            onClick={() =>
              this.props.onCanvasserSelect(
                canvasser_id,
                this.props.seat.routeseat_id,
                this.props.seat.crewcanvasser_id,
                true
              )
            }
          >
            <i style={{ fontSize: ".8em" }} className={"fas fa-user-slash"} />
          </span>
        </div>
      </div>
    );
  };

  generateUnnassignedDataLine = () => {
    return (
      <>
        <div className={`canvasser-line`}>
          <div className={"unnasigned-tag line-item"}>
            Unnassigned: {this.props.seat.sites.length} sites
          </div>
        </div>
        <div className={`canvasser-line`}>
          {!this.state.editingAssignmentPlaceholder && (
            <div
              className={"unnasigned-tag line-item clickable"}
              onDoubleClick={() =>
                this.setState({ editingAssignmentPlaceholder: true }, () => {
                  this.commentsInputRef.current.focus();
                })
              }
            >
              {this.state.assignmentPlaceholderValue &&
              this.state.assignmentPlaceholderValue.length ? (
                <span className={"primary-text"}>
                  {this.state.assignmentPlaceholderValue}
                </span>
              ) : (
                <span
                  style={{
                    opacity: 0.7,
                    fontStyle: "italic",
                    fontSize: ".8em",
                  }}
                >
                  Add a note about how to assign this seat.
                </span>
              )}
            </div>
          )}
          {this.state.editingAssignmentPlaceholder && (
            <input
              className={"edit-toggle"}
              type="text"
              value={this.state.assignmentPlaceholderValue}
              onChange={(ev) => {
                let val = ev.target.value;
                this.setState({
                  assignmentPlaceholderValue: val.length ? val : null,
                });
              }}
              onBlur={() => {
                this.setState({ editingAssignmentPlaceholder: false });
                this._setAssignmentNote({
                  note: this.state.assignmentPlaceholderValue,
                  routeseat: this.props.seat.routeseat_id,
                  shift: this.props.sr_data.shift,
                });
              }}
              ref={this.commentsInputRef}
            />
          )}
        </div>
      </>
    );
  };

  render() {
    return (
      <div
        className={`crew-seat`}
        key={this.props.draggableId + "-" + this.props.seat.routeseat_id}
        style={{ borderColor: this.props.color }}
      >
        <Droppable
          droppableId={
            "routeseat-assign_" +
            this.props.seat.routeseat_id +
            "_crew_" +
            this.props.crew_id
          }
        >
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              className={snapshot.isDraggingOver ? "primary light" : ""}
            >
              <div className={"inputWrapper"}>
                {!!this.props.seat.canvasser_id &&
                  !this.state.editing &&
                  this.generateCanvasserDataLine(this.props.seat.canvasser_id)}
                {/*{!!this.props.seat.canvasser_id && !!this.state.editing && this.generateCanvasserDataLine(this.props.seat.canvasser_id)}*/}
                {!this.props.seat.canvasser_id &&
                  this.generateUnnassignedDataLine()}
              </div>
              {this.props.displaySites && (
                <div className="seat-site-list">
                  {_get(this.props, "seat.sites", []).map((s, i) => (
                    <div
                      className="seat-site"
                      key={
                        "seat-site-list" +
                        this.props.draggableId +
                        this.props.seat.routeseat_id +
                        i
                      }
                      style={{ borderColor: this.props.color }}
                    >
                      <div
                        className="site-name"
                        style={{ color: this.props.color }}
                      >
                        {s.site_name}
                      </div>
                      <div className="site-address">
                        {s.addressline1}, {s.city}, {s.statecode}, {s.zip5}
                      </div>
                      <div
                        className={"notes-in-table"}
                        onClick={() =>
                          this.props.setSiteNoteModalSite({
                            ...s,
                            name: s.site_name,
                            id: s.site_id,
                          })
                        }
                      >
                        <NoteTagList addButton notes={s.notes} />
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </div>
    );
  }
}

class DraggableSiteRouteCrew extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isExpanded: true,
    };
  }

  _renderSitesData(sites) {
    let sitesCount = 0;
    // TODO: render appropriate site metadata based on column or droppable context here.
    if (this.props.availableRoute) {
      // just render number of sites for now
      return this.sites.length;
    }
  }

  _getCanvasserOptions = () => {
    let options = (this.props.canvassers || []).map((d) => {
      return {
        display: d.firstname + " " + d.lastname,
        value: d.id,
      };
    });

    options.unshift({ display: "", value: 0 });
    return options;
  };

  _renderRouteSeats(crew_id) {
    if (!this.props.routeseats) return null;

    let sortedSeats = this.props.routeseats
      .slice()
      .sort((a, b) => a.seat_order_position - b.seat_order_position);
    let driver = sortedSeats[sortedSeats.length - 1];

    let seats = sortedSeats.map((item, index) => {
      return (
        <RouteSeatAssigment
          {...this.props}
          seat={item}
          key={item.routeseat_id}
          first={index === 0}
          driver={item === driver}
          color={this.props.color}
        />
      );
    });
    return seats;
  }

  handleBeforeSRDrag = () => {
    document.getElementById("crew-drop-mat").className = "crew-drop-mat active";
    document.getElementById("crewlist").className = "crewlist inactive";
  };

  _renderAvailableSiteRoute(provided, snapshot) {
    return (
      <div
        className={`schedule-sr-card`}
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...{
          ...provided.dragHandleProps,
          onMouseDown: () => {
            this.handleBeforeSRDrag();
          },
          onMouseUp: () => {
            document.getElementById("crew-drop-mat").className =
              "crew-drop-mat testing";

            document.getElementById("crewlist").className = "crewlist";
          },

          onContextMenu: () => {
            document.getElementById("crew-drop-mat").className =
              "crew-drop-mat";
            document.getElementById("crewlist").className = "crewlist";
          },
        }}
      >
        <div
          className="available-route"
          style={{ borderLeftColor: this.props.color, color: this.props.color }}
          id={this.props.id}
        >
          <div className="obj-title">{this.props.name}</div>
          <div className="obj-data">
            {this.props.routeseats ? this.props.routeseats.length : 0} seats
          </div>
        </div>
      </div>
    );
  }

  _generateIncludedRoles() {
    let roles = this.props.routeseats.reduce((agg, d, i, a) => {
      return agg.concat(d.roles);
    }, []);

    roles = roles
      .sort((a, b) => a.id - b.id)
      .filter((d) => d?.id)
      .map((role, i) => {
        return <AvailRoleToken role={(role || {}).name} key={i} />;
      });

    return <span className="crew-role-tokens">{roles}</span>;
  }

  _generateRouteToAllSitesToggle = () => {
    if (!this.props.routeseats) return;
    let shouldDisplay;

    if (this.props.routeseats.length === 1) {
      shouldDisplay = true;
    } else if (
      _get(this.props, "routeseats[0].sites", []).length &&
      ![...this.props.routeseats.slice(1, 1000)].some((d) => d.sites.length)
    ) {
      shouldDisplay = true;
    } else {
      shouldDisplay = false;
    }

    if (!shouldDisplay) return <></>;

    return (
      <div
        className={"crew-subtitle"}
        style={{ color: _get(this.props, "sr_data.hex_color") }}
      >
        <Input
          type="checkbox"
          title="Smart Order and Route to All Sites"
          onChange={this.props.onRouteToAllSitesToggle}
          checked={this.props.sr_data.route_to_all_sites}
        />
      </div>
    );
  };

  _renderCrewCard(provided, snapshot) {
    let innerCard = (
      <>
        <div className={"crew-card-top-icons"}>
          <div className={"crew-card-top-icons-left"}>
            {this.state.isExpanded ? (
              <i
                className="remove-crew-icon fa fa-angle-down"
                onClick={() => this.setState({ isExpanded: false })}
              />
            ) : (
              <i
                className="remove-crew-icon fa fa-chevron-right"
                onClick={() => this.setState({ isExpanded: true })}
              />
            )}
          </div>
          <div className={"crew-card-top-icons-right"}>
            <i
              className="remove-crew-icon far fa-edit"
              onClick={() =>
                window.open(
                  `/sitecanvass/${this.props.sitecanvass}/quickedit/?siteroute=${this.props.sr_data.siteroute_id}`,
                  "_blank"
                )
              }
            ></i>
            <i
              className="remove-crew-icon far fa-times-circle"
              onClick={this.props.onDeleteClick}
            ></i>
          </div>
        </div>
        <div className={"crew-title"} style={{ color: this.props.color }}>
          {this.props.name} {this._generateIncludedRoles()}{" "}
          {this._generateRouteToAllSitesToggle()}
        </div>
        {this.state.isExpanded ? (
          <div className={"seat-wrapper"}>{this._renderRouteSeats()}</div>
        ) : null}
      </>
    );

    if (provided && snapshot) {
      return (
        <div
          className={`assign-crew-card`}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          {innerCard}
        </div>
      );
    } else {
      return <div className={`assign-crew-card`}>{innerCard}</div>;
    }
  }

  // TODO: add classNames conditionally based off of which scheduling column the siteroute is in
  // TODO: need different class for the remove icon
  render() {
    let { draggableId, draggable, cardInDraggableContext } = this.props;
    return cardInDraggableContext !== false ? (
      <Draggable
        draggableId={draggableId}
        index={this.props.index}
        key={this.props.draggableId + this.props.index}
      >
        {(provided, snapshot) => (
          <>
            {this.props.availableRoute &&
              this._renderAvailableSiteRoute(provided, snapshot)}
            {!this.props.availableRoute &&
              this._renderCrewCard(provided, snapshot)}
          </>
        )}
      </Draggable>
    ) : (
      this._renderCrewCard()
    );
  }
}

const mapStateToProps = (state) => ({
  canvassers: state.canvassers.data,
});

// TODO: is this necessary on this page?
const mapDispatchToProps = (dispatch) => ({
  setSiteNoteModalSite: (site) =>
    dispatch(setSessionVar("siteNoteModalSite", site)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DraggableSiteRouteCrew);

/*


EXAMPLE OF PASSED IN DATA
{
  "siteroute_id": 2202,
  "siteroute_name": "Downtown Denver",
  "hex_color": "#e7298a",
  "created_at": "2020-03-04T22:25:29.464503",
  "sitecanvass_id": 1,
  "routeseats": [
    {
      "routeseat_id": 13912,
      "canvasser_type_id": 3,
      "type_name": "Canvasser",
      canvasser_id: 88,
      crewcanvasser_id: 12112,
      "sites": [
        {
          "routeseatsite_id": 91657,
          "site_order_position": 2,
          "site_id": 2,
          "site_name": "Torchy's Tacos Yum!",
          "description": "",
          "addressline1": "2809 S 1st St",
          "city": "Austin",
          "statecode": "TX",
          "zip5": "78704",
          "lat": "30.2367541",
          "lon": "-97.76280109999999"
        },
        {
          "routeseatsite_id": 92059,
          "site_order_position": 1,
          "site_id": 3,
          "site_name": "Tacos Matamoros",
          "description": "",
          "addressline1": "10304 N Lamar Blvd",
          "city": "Austin",
          "statecode": "TX",
          "zip5": "78753",
          "lat": "30.3726117",
          "lon": "-97.6920146"
        }
      ]
    }
  ],
  "crew_id": 31484
}

 */
